import React from "react";
import styled from "styled-components";
import * as colors from "../settings/colors";
import modalWrapper from "../hocs/modalWrapper";

export const InnerModalContainer = styled.div`
  display: block;
  flex: 1 0 auto;
  max-width: 800px;
  padding-top: 10vh;

  @media only print {
    width: auto;
    height: auto;
    max-width: 100%;
    padding-top: 0.25in;
    overflow-x: visible;
  }
`;

const ModalContainer = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: white;
  z-index: 1000;
  overflow-y: auto;
  justify-content: center;

  @media only print {
    display: block !important;
    position: static;
    width: auto;
    height: auto;
    box-shadow: none;
    overflow-x: visible;
    overflow-y: visible;
  }
`;

export const CloseButton = styled.a.attrs({
  children: "×"
})`
  display: block;
  color: ${colors.TEXT_SECONDARY};
  width: 48px;
  height: 48px;
  text-align: center;
  position: fixed;
  top: 40px;
  right: 80px;
  font-weight: 300;
  font-size: 48px;
  line-height: 40px;
  border-radius: 50%;
  cursor: pointer;

  &:hover {
    color: ${colors.TEXT};
    background: ${colors.DIVIDER};
  }

  @media only print {
    display: none;
  }
`;

// TODO: Allow esc to close modal

class FullScreenModal extends React.Component {
  static defaultProps = {
    isOpen: false,
    layout: "default",
    style: {}
  }
  
  render() {
    const { isOpen, close, layout = "default", children, style } = this.props;

    return isOpen && (
      <ModalContainer
        style={style}
      >
        {layout !== "default" ? (
          children
        ) : (
          <React.Fragment>
            <CloseButton onClick={close} />
            <InnerModalContainer>{children}</InnerModalContainer>
          </React.Fragment>
        )}
      </ModalContainer>
    );
  }
}

export default modalWrapper(FullScreenModal);



// WEBPACK FOOTER //
// ./src/components/FullScreenModal.js